export const getAvatarImageUrl = (value) => {
  if (value === null || value === undefined) return null;

  const normalized = String(value).trim();
  if (!normalized) return null;

  const invalidValues = new Set(["False", "false", "None", "null"]);
  return invalidValues.has(normalized) ? null : normalized;
};

